import { getBranchCodeFromPath, getBranchData, isValidBranchCode } from '../config/branches-config';

export function getLeadFormBranch(pathname: string, search: string) {
  const requested = new URLSearchParams(search).get('branch');
  const isCalculationPage = /^\/(?:[a-z]{2}\/)?raschet-(?:konstruktsii|zdaniya|ferm)\/?$/.test(pathname);
  return isCalculationPage && requested && isValidBranchCode(requested) ? requested : getBranchCodeFromPath(pathname);
}

export function getLeadFormCity(pathname: string, search: string) {
  return getBranchData(getLeadFormBranch(pathname, search))?.name || 'Санкт-Петербург';
}
